import React from "react";
import { Container } from "./style";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";
import { ContentOrLoading } from "../../Loadings/ContentOrLoading";
import { FormChangePassword } from "./form";

interface IModalChangePassword {
    onCancel: Function;
    onSave: Function;
    openModal: boolean;
}

const texts: any = {
    title: "Alterção de senha",
    subTitle: "Informe sua senha antiga e sua nova senha escolhida",
};

export const ModalChangePassword: React.FC<IModalChangePassword> = (props) => {
    const { onCancel, openModal, onSave } = props;

    const { theme } = useGlobal();

    return (
        <ModalGeneric
            backgroundVisible={false}
            open={openModal}
            onClose={() => { }}
        >
            <Container theme={theme}>
                <ModalHeader
                    title={texts.title}
                    subTitle={texts.subTitle}
                    onCancel={() => onCancel()}
                    theme={theme}
                />
                <ContentOrLoading type="wave" loading={false} theme={theme}>
                    <FormChangePassword
                        onSave={onSave}
                        onCancel={onCancel}
                    />
                </ContentOrLoading>
            </Container>
        </ModalGeneric>
    );
};
